import { useEffect, useState } from 'react';
import { useLazyGetGeoZonesQuery } from '../geoZone/redux/geoZone.api';

export function useGeoZonesInBatches(allIds, batchSize = 50) {
  const [data, setData] = useState([]);
  const [trigger] = useLazyGetGeoZonesQuery();
  const [currentBatch, setCurrentBatch] = useState(0);

  const totalBatches = Math.ceil(allIds.length / batchSize);

  useEffect(() => {
    setData([]);
    setCurrentBatch(0);
  }, [allIds]);

  useEffect(() => {
    if (!allIds.length) return;

    const fetchNextBatch = async () => {
      if (currentBatch >= totalBatches) return;

      const batchIds = allIds.slice(currentBatch * batchSize, (currentBatch + 1) * batchSize);
      const result = await trigger({ params: { 'geozoneId.in': batchIds.join(','), size: batchIds.length } }).unwrap();

      setData((prev) => [...prev, ...result.data]);
      setCurrentBatch((prev) => prev + 1);
    };

    fetchNextBatch();
  }, [allIds, batchSize, currentBatch, totalBatches, trigger]);

  return data;
}

export default useGeoZonesInBatches;
